import React from 'react';
import type { AtlasStatus } from './atlasApi';

const MAPA: Record<AtlasStatus, { label: string; classes: string }> = {
  ativo: { label: 'Ativo', classes: 'bg-emerald-100 text-emerald-700' },
  demitido: { label: 'Demitido', classes: 'bg-gray-200 text-gray-600' },
  removido_gix: { label: 'Removido GIX', classes: 'bg-amber-100 text-amber-700' },
};

const BadgeStatus: React.FC<{ status?: string }> = ({ status }) => {
  const item = MAPA[(status || 'ativo') as AtlasStatus] || MAPA.ativo;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider ${item.classes}`}>
      {item.label}
    </span>
  );
};

export default BadgeStatus;
